import { createCn } from "cn/config";

export const cn = createCn({
  extend: {
    classGroups: {
      typography: [
        "title-xl",
        "title-lg",
        "title-md",
        "title-sm",
        "title-xs",
        "body-xl",
        "body-lg",
        "body-md",
        "body-sm",
        "body-lg-semibold",
        "body-md-semibold",
        "body-sm-semibold",
        "link",
        "link-bold",
        "button-xl",
        "button-lg",
        "button-md",
        "button-sm",
        "placeholder-label-xl",
        "placeholder-label-md",
        "input-label-xl",
        "input-label-md",
        "input-label-md-bold",
        "floating-label-md",
        "floating-label-sm",
      ],
    },
  },
});
